module.exports = __webpack_public_path__ + "img/utsuho reiuji.696ce813.png";